import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IMAGE_LINQ } from '../../model-services/model-item-enums';
import { AppComponent } from '../../app.component';

// shown after registering: explains the activation email and what to do if it doesn't arrive
@Component({
    selector: 'app-registered',
    templateUrl: './registered.html',
    styleUrls: ['./registered.css'],
    standalone: false
})
export class RegisteredComponent {
    IMAGE_LINQ=IMAGE_LINQ
    email:string|undefined

    constructor(router:Router, public app:AppComponent) {
        // the registration page passes the email in the navigation state; it is kept in the browser's history, so a refresh still has it
        const state = router.currentNavigation()?.extras.state || history.state
        this.email = typeof state?.email === 'string' ? state.email : undefined
    }
}
